// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1VHp3","buttons":"PendingPaymentAlert_buttons__3Oyby"};